var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOrder2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_internet-speed-performance-upgrade-online_5981599",
    transform: "translate(-5.274 -5.274)",
    opacity: 0.399
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M120.093,232.065h97.362c-3.27,10.285-6.435,18.671-8.65,24.209-1.9,4.747-3.112,7.437-3.112,7.437H131.855s-1.213-2.69-3.112-7.437C126.528,250.735,123.363,242.349,120.093,232.065Z",
    fill: "#fcd770"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M232.065,147.677a231.36,231.36,0,0,1-3.428,38.554c-1.108,6.8-2.479,13.344-3.956,19.62-2.215,9.6-4.8,18.46-7.226,26.213H120.093c-2.426-7.753-5.01-16.614-7.226-26.213a267.9,267.9,0,0,1-6.962-45.885c-.264-4.061-.422-8.175-.422-12.289,0-30.485,12.236-60.97,24.947-84.387h76.687C219.828,86.708,232.065,117.193,232.065,147.677Z",
    fill: "#ffeaa7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M131.855,263.71h15.823l-21.1,21.1,9.23,10.548H47.468a36.919,36.919,0,0,1,0-73.839,38.583,38.583,0,0,1,5.538.475,68.5,68.5,0,0,1,52.847-62.025h.053a267.9,267.9,0,0,0,6.962,45.885,24.944,24.944,0,0,0-23.206,24.841,25.293,25.293,0,0,0,3.27,12.394l17.827,31.171,17.985-17.985C130.642,261.02,131.855,263.71,131.855,263.71Z",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M279.532,200.419a47.468,47.468,0,0,1,0,94.936H201.738l9.23-10.548-21.1-21.1h15.823s1.213-2.69,3.112-7.437l17.985,17.985,17.827-31.171a25.293,25.293,0,0,0,3.27-12.394,24.944,24.944,0,0,0-23.206-24.841c1.477-6.276,2.848-12.816,3.956-19.62a47.491,47.491,0,0,1,27.584,20.306A47.692,47.692,0,0,1,279.532,200.419Z",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M189.871,263.71l21.1,21.1-9.23,10.548L174.048,327H163.5l-27.69-31.645-9.23-10.548,21.1-21.1h21.1a10.625,10.625,0,0,0-10.548,10.548v2.057a10.365,10.365,0,0,0,1.793,5.854l8.755,13.185,8.755-13.185a10.365,10.365,0,0,0,1.793-5.854v-2.057a10.579,10.579,0,0,0-10.548-10.548Z",
    fill: "#ff826e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M179.323,276.315a10.365,10.365,0,0,1-1.793,5.854l-8.755,13.185-8.755-13.185a10.365,10.365,0,0,1-1.793-5.854v-2.057a10.625,10.625,0,0,1,10.548-10.548,10.579,10.579,0,0,1,10.548,10.548Z",
    fill: "#fc6e51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M247.887,230.693a25.293,25.293,0,0,1-3.27,12.394L226.79,274.258l-17.985-17.985c2.215-5.538,5.38-13.924,8.65-24.209,2.426-7.753,5.01-16.614,7.226-26.213A24.944,24.944,0,0,1,247.887,230.693Z",
    fill: "#ff826e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M128.743,256.273l-17.985,17.985L92.931,243.088a25.293,25.293,0,0,1-3.27-12.394,24.944,24.944,0,0,1,23.206-24.841c2.215,9.6,4.8,18.46,7.226,26.213C123.363,242.349,126.528,250.735,128.743,256.273Z",
    fill: "#ff826e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M207.118,63.29H130.431a300.89,300.89,0,0,1,20.991-33.333,21.421,21.421,0,0,1,34.7,0A300.89,300.89,0,0,1,207.118,63.29Z",
    fill: "#ff826e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M168.774,94.935a42.182,42.182,0,0,0-42.194,42.194,41.408,41.408,0,0,0,5.7,21.1,42.119,42.119,0,0,0,72.995,0,41.408,41.408,0,0,0,5.7-21.1A42.182,42.182,0,0,0,168.774,94.935Z",
    fill: "#69d6f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 10.548,
    cy: 10.548,
    r: 10.548,
    transform: "translate(158.226 137.129)",
    fill: "#fcd770"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M49.63,15.348,68.565,58.016H52.742v100.21h-21.1V58.016H15.823L34.757,15.348a8.161,8.161,0,0,1,14.873,0Z",
    fill: "#0bd19f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M302.791,15.348l18.934,42.668H305.9v100.21h-21.1V58.016H268.984l18.934-42.668a8.161,8.161,0,0,1,14.873,0Z",
    fill: "#0bd19f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M279.532,195.145a52.762,52.762,0,0,0-21.619,4.652,52.666,52.666,0,0,0-23.338-17.173,237.015,237.015,0,0,0,2.764-34.947c0-50.8-32.848-101.417-46.961-120.821a26.666,26.666,0,0,0-43.206,0c-14.114,19.4-46.961,70.02-46.961,120.821,0,2.779.074,5.554.185,8.323a74.4,74.4,0,0,0-52.1,60.252c-.28-.011-.554-.011-.828-.011a42.194,42.194,0,0,0,0,84.387h85.948l27.69,31.645h15.337l27.69-31.645h75.4a52.742,52.742,0,1,0,0-105.484Zm-144.207,63.29c-1.63-3.9-4.594-11.313-7.906-21.1h82.71c-3.312,9.784-6.276,17.2-7.906,21.1Zm38.723,15.823v2.083a5.3,5.3,0,0,1-.886,2.927l-4.388,6.577-4.388-6.582a5.3,5.3,0,0,1-.886-2.922v-2.083a5.274,5.274,0,1,1,10.548,0Zm-51.5-19.246-10.638,10.638L97.53,240.487a19.568,19.568,0,0,1,11.35-28.481A366.432,366.432,0,0,0,122.546,255.013Zm106.122-43.006a19.559,19.559,0,0,1,11.345,28.481l-14.377,25.158L215,255.007A364.8,364.8,0,0,0,228.668,212.007ZM155.7,33.064a16.117,16.117,0,0,1,26.149,0c4.188,5.754,10.1,14.383,16.26,24.952h-58.67C145.6,47.447,151.512,38.818,155.7,33.064Zm-22.088,35.5h70.321c11.809,22.389,22.858,50.838,22.858,79.113,0,28.7-6.693,57.584-13.28,79.113H124.038c-6.587-21.529-13.28-50.416-13.28-79.113C110.758,119.4,121.808,90.953,133.611,68.565ZM47.468,290.081A31.646,31.646,0,1,1,52.2,227.186l5.643.849.4-5.7a63.719,63.719,0,0,1,42.842-55.5,282.3,282.3,0,0,0,5.38,34.852,30.133,30.133,0,0,0-18.1,44.029l21.223,37.146,17.3-17.3c.063.137.116.264.148.327l1.413,3.091h6.487l-15.58,15.585,4.826,5.512Zm124.186,31.645h-5.759l-32.1-36.682,16.065-16.06h4.061a15.644,15.644,0,0,0-.97,5.274v2.083a15.791,15.791,0,0,0,2.658,8.776l13.164,19.747,13.164-19.752a15.766,15.766,0,0,0,2.658-8.776v-2.078a15.645,15.645,0,0,0-.97-5.274h4.061l16.065,16.06Zm107.878-31.645H213.357l4.826-5.512L202.6,268.984h6.487l1.408-3.091c.026-.063.084-.185.148-.327l17.3,17.3,21.223-37.141a30.153,30.153,0,0,0-18.1-44.04q.894-4.13,1.7-8.4A42.23,42.23,0,0,1,251.785,209.4l2.69,4.209,4.351-2.458a42.185,42.185,0,1,1,20.706,78.934Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M26.371,158.226H36.919V52.742H23.94L39.6,17.51a2.957,2.957,0,0,1,5.19,0L60.448,52.742H47.468V158.226H58.016V63.29H76.682L54.43,13.222a13.393,13.393,0,0,0-24.472,0L7.706,63.29H26.371Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M279.532,158.226h10.548V52.742H277.1L292.76,17.51a2.957,2.957,0,0,1,5.19,0l15.659,35.232h-12.98V158.226h10.548V63.29h18.665L307.591,13.222a13.393,13.393,0,0,0-24.472,0L260.867,63.29h18.665Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M168.774,184.6a47.468,47.468,0,1,0-47.468-47.468A47.522,47.522,0,0,0,168.774,184.6Zm-25.786-21.1h51.576a36.8,36.8,0,0,1-51.576,0ZM163.5,147.677a5.274,5.274,0,1,1,5.274,5.274A5.28,5.28,0,0,1,163.5,147.677Zm5.274-47.468a36.833,36.833,0,0,1,33.307,52.742H183.626a15.543,15.543,0,0,0-9.578-20.126V110.758H163.5v22.067a15.543,15.543,0,0,0-9.578,20.126H135.468a36.833,36.833,0,0,1,33.307-52.742Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 10.548,
    height: 10.548,
    transform: "translate(26.371 168.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 10.548,
    height: 10.548,
    transform: "translate(300.629 168.774)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrder2);
export default __webpack_public_path__ + "static/media/no-order-2.780cff287996249eb75969bbb766f29d.svg";
export { ForwardRef as ReactComponent };